import { render, staticRenderFns } from "./vueQRCodeReader.vue?vue&type=template&id=06d59182&scoped=true"
import script from "./vueQRCodeReader.vue?vue&type=script&lang=js"
export * from "./vueQRCodeReader.vue?vue&type=script&lang=js"
import style0 from "./vueQRCodeReader.vue?vue&type=style&index=0&id=06d59182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d59182",
  null
  
)

export default component.exports